import { FunctionComponent } from 'react';
import { Global, css } from '@emotion/react';
import { Theme, InkDocuSignTheme, CustomBranding } from '@ds/ui';
import { AppMessenger } from '@ds/components';

//--tile-hover-border-color: rgba(25, 24, 35, 0.9); - should be ${inkButtonTokens.secondary.hoverBorderColor}; but that's not defined in the token...
const ApplicationLayoutGlobalStyles = css`
    html,
    body,

    #root {
        height: 100%;
        display: flex;
        flex-direction: column;
        min-width: 320px;
    }

    .hidden {
        display: none;
    }

    .inline {
        display: inline;
    }

    [tabIndex='-1']:focus {
        outline: none;
    }

    #root > footer {
        overflow: visible;
    }
`;

export interface ApplicationLayoutProps {
    header: FunctionComponent;
    content: FunctionComponent;
    footer: FunctionComponent;
    accountBranding?: CustomBranding;
}

const ApplicationLayout: FunctionComponent<ApplicationLayoutProps> = ({ header: Header, content: Content, footer: Footer, accountBranding }) => (
    <Theme enableGlobalCss enableFontFaceDeclarations docuSignTheme={InkDocuSignTheme} accountBranding={accountBranding}>
        <AppMessenger>
            <Global styles={ApplicationLayoutGlobalStyles} />
            <Header />
            <Content />
            <Footer />
        </AppMessenger>
    </Theme>
);

export default ApplicationLayout;
